import * as _ from 'underscore';
import * as angular from 'angular';
import { ShopService } from '../../shop.service';
import { CampaignListItem } from '../../../core';
import { ICampaignListItem } from '../../../campaigns/models';
import { RetailerService } from '../../../api/retailer.service';
import { CampaignsService } from '../../../campaigns/services/campaigns.service';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { CommonCampaignsService } from '../../../../../app.retailer.common/modules/services/commonCampaigns.service';

interface ICampaignFilterStatus {
    key: string;
    value: number;
}

interface IShopCampaignsFilter {
    from: Date;
    to: Date;
    selectedStatus: ICampaignFilterStatus;
    statuses: ICampaignFilterStatus[];
    dateOptions: {
        formatYear: string,
        startingDay: number;
    };
}

export class ShopCampaignsController {
    static $inject = ['shopService', 'campaignsService', 'commonCampaignsService', 'retailerService', 'notificationService'];

    waiting: boolean = false;
    campaigns: CampaignListItem[] = [];
    filter: IShopCampaignsFilter = {
        from: null,
        to: null,
        selectedStatus: null,
        statuses: [],
        dateOptions: {
            formatYear: 'yyyy',
            startingDay: 0
        }
    };
    allCampaigns: ICampaignListItem[] = [];
    previewImgSize = {
        w: 64,
        h: 32
    };
    campaignsLoaded: boolean = false;
    shopID: number = null;

    private allStatuses: ICampaignFilterStatus = {
        key: 'All',
        value: null
    };
    private status = this.commonCampaignsService.getCampaignStatus();

    constructor(
        private shopService: ShopService,
        private campaignsService: CampaignsService,
        private commonCampaignsService: CommonCampaignsService,
        private retailerService: RetailerService,
        private notificationService: NotificationService,
    ) {

        var statuses: ICampaignFilterStatus[] = [this.allStatuses];

        for (var key in this.status) {
            if (this.status.hasOwnProperty(key) && !_.isFunction(this.status[key]) && key.toLowerCase() !== 'undefined' &&
                this.status[key] !== this.status.Warning && this.status[key] !== this.status.Disabled) {
                statuses.push({
                    key: key,
                    value: this.status[key]
                });
            }
        }
        this.filter.statuses = statuses;
        this.filter.selectedStatus = this.allStatuses;
    }

    $onChanges(changes: any) {
        if (changes.shopId && changes.shopId.isFirstChange()) {
            this.shopID = changes.shopId.currentValue;
            this.getCampaigns(this.shopID);
        }
    }

    applyFilter = () => {
        this.campaigns = this.allCampaigns;

        if (this.filter.selectedStatus.key !== this.allStatuses.key) {
            this.campaigns = _.where(this.campaigns, { 'Status': this.filter.selectedStatus.value });
        }

        if (this.filter.from) {
            this.campaigns = _.filter(this.campaigns, (campaign) => {

                return campaign.StartDate && new Date(campaign.StartDate.toString()).setHours(0, 0, 0) <= new Date(this.filter.from.toString()).setHours(0, 0, 0);
            });
        }

        if (this.filter.to) {
            this.campaigns = _.filter(this.campaigns, (campaign) => {

                return campaign.EndDate && new Date(campaign.EndDate.toString()).setHours(0, 0, 0) >= new Date(this.filter.to.toString()).setHours(0, 0, 0);
            });
        }
    }

    setState = async (campaign) => {
        this.waiting = true;
        this.notificationService.showWaitingMessage();

        try {
            await this.campaignsService.setState(campaign.ID, !campaign.enabled);
            this.notificationService.clearAll();
            await this.getCampaigns(this.shopID);
        } catch (error) {
            campaign.enabled = !campaign.enabled;
            this.notificationService.showErrorMessage(error);
        }

        this.waiting = false;
    }

    private setCampaignState = (campaign) => {
        campaign.enabled = campaign.Status !== this.status.Draft;
        campaign.hideState = campaign.Status === this.status.Archived;
    }

    private getCampaigns = async (id: number) => {
        try {

            var pagingResult = await this.shopService.getStoreCampaigns(id);
            this.allCampaigns = <ICampaignListItem[]>pagingResult.Items;

            _.forEach(this.allCampaigns, (campaign) => {
                campaign.StartDate = campaign.StartDate ? new Date(campaign.StartDate.toString()) : null;
                campaign.EndDate = campaign.EndDate ? new Date(campaign.EndDate.toString()) : null;
                campaign.image = campaign.ImageID ? this.retailerService.getCampaignImageUrl(campaign.ImageID, this.previewImgSize.w, this.previewImgSize.h) : null;
                campaign.video = campaign.VideoID ? this.retailerService.getCampaignThumbnailImageUrl(campaign.VideoID, this.previewImgSize.w, this.previewImgSize.h) : null;
                this.setCampaignState(campaign);
            });

            this.applyFilter();
            this.campaignsLoaded = true;
            this.campaignsService.resizeFontWithTimeOut();

        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
    }
}

angular.module('naut').component('shopCampaigns', {
    template: require('./shopCampaigns.html'),
    controller: ShopCampaignsController,
    controllerAs: '$ctrl',
    bindings: {
        shopId: '<',
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/places/components/shopCampaigns/shopCampaigns.component.ts